<template>
  <div id="qrcode"></div>
</template>

<script>
import QRCode from "qrcodejs2"; //引入生成二维码插件
export default {
   methods:{
       creatQrCode() {
        var qrcode = new QRCode(this.$refs.qrCodeUrl, {
            text: 'xxxx',
            width: 100,
            height: 100,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        })
        console.log(qrcode)
        },
   },
    mounted(){
    new QRCode(document.getElementById("qrcode"), "http://jindo.dev.naver.com/collie");
    //  var qrcode = new QRCode("test", {
    //     text: "http://jindo.dev.naver.com/collie",
    //     width: 128,
    //     height: 128,
    //     colorDark : "#000000",
    //     colorLight : "#ffffff",
    //     correctLevel : QRCode.CorrectLevel.H
    // });
    // qrcode.makeCode("http://naver.com"); // make another code.
    },
}
</script>

<style  lang="less" scoped>
    #id{
        width: 100px;
        height: 100px;
    }
</style>